import type { FC } from 'react';
import React, { memo, useMemo, useState } from 'react';

import type {
	PageCardAppearance as PageCardAppearanceType,
	PageCard as PageCardType,
} from './card-types.ts';
import { PageCardContext } from './PageCardContext.ts';
import { QuickActionsEnum } from './Items/QuickActions/QuickActionsEnum.ts';
import type { AnalyticsData } from './PageCards.tsx';

export type PageCardContextProviderProps = {
	appearance: PageCardAppearanceType;
	data: PageCardType;
	smallCard?: boolean;
	ranking?: number;
	analyticsData?: AnalyticsData;
	children?: React.ReactNode;
};

export const PageCardContextProvider: FC<PageCardContextProviderProps> = memo(
	({ appearance, data, ranking, analyticsData, children, smallCard }) => {
		const [isMenuOpen, setIsMenuOpen] = useState(false);
		const [isViewed, setIsViewed] = useState(false);
		const [selectedMenuItems, setSelectedMenuItems] = useState({
			[QuickActionsEnum.ShareButton]: false,
			[QuickActionsEnum.WatchButton]: false,
		});
		const pageCardContextValue = useMemo(() => {
			return {
				...data,
				appearance,
				setIsMenuOpen,
				isMenuOpen,
				ranking,
				setSelectedMenuItems,
				selectedMenuItems,
				analyticsData,
				isViewed,
				setIsViewed,
				smallCard,
			};
		}, [
			data,
			appearance,
			ranking,
			analyticsData,
			isMenuOpen,
			selectedMenuItems,
			isViewed,
			smallCard,
		]);

		return (
			<PageCardContext.Provider value={pageCardContextValue}>{children}</PageCardContext.Provider>
		);
	},
	(prevProps, nextProps) =>
		prevProps.appearance === nextProps.appearance &&
		prevProps.data.isStarred === nextProps.data.isStarred,
);
